<script lang="ts">
  import { fade } from 'svelte/transition'

  export let open = false
  export let transitionDuration = 400
</script>

<div
  class="fixed inset-0 z-10 bg-gray-800 opacity-75"
  class:hidden={!open}
  in:fade={{ duration: transitionDuration }}
  out:fade={{ duration: 1.5 * transitionDuration }}
/>
